import { render } from "./PsychologistViewEvaluationView.vue?vue&type=template&id=67642af9"
import script from "./PsychologistViewEvaluationView.vue?vue&type=script&lang=js"
export * from "./PsychologistViewEvaluationView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__